import _ from "lodash"
import { connect } from "react-redux"
import React, { PureComponent } from "react"
import { withApi } from "@tencent/react-aio"
import { getMessage } from "@/utils/MessageUtils"
import TeamInfo from "@/business-components/sale/TeamInfo"
import UserInfo from "@/business-components/sale/UserInfo"
import IndustryInfo from "@/business-components/sale/IndustryInfo"
import MessageBox from "@/components/MessageBox"
import { Dialog } from "@tencent/spaui"
import { Tabs, TabPanel } from "@tencent/spaui"

class AccountDialog extends PureComponent {
  render() {
    const { children } = this.props

    let Formlistwidth = {
      width: "900px",
    }

    return (
      <div className="AccountDetail">
        <Dialog {...this.props} backdrop hideFooter type="normal" onClose={this.props.onClose} onCancel={this.props.onClose} title="账户详情" style={Formlistwidth}>
          {children}
        </Dialog>
      </div>
    )
  }
}

class AccountDetail extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      key: "1",
      ownerId: "",
      customerId: "",
      weChatAppId: "",
      customerMpUserName: "",
      basicInfo: {
        buyingType: "",
        uname: "",
        websiteUrl: "",
        licenseNo: "",
        licenseImageUrl: "",
        areaCode: "",
        legalPersonName: "",
        legalPersonIdentityNo: "",
        legalPersonPositive: "",
        legalPersonNegative: "",
        tmallAdvertiserAdtype: "",
      },
      industryInfo: {
        industry_id: "",
        industry_certifications_list: "",
      },
      advertisingInfo: {
        operation_mode: "",
        ad_platform_type: "",
        promoted_object: "",
        promotion_business: "",
        day_budget_promised: "",
        online_time_promised: "",
        effect_promised: "",
        memo_promised: "",
        competition: "",
        landing_page_url: "",
        creative_attachment_ids: "",
        creative_attachments: null,
        advertising_info_id: "",
      },
      lead: {},
    }

    this.handleChange = this.handleChange.bind(this)
  }

  componentDidMount() {
    const { tickedId } = this.props
    this.getAdvertisinDataAsync(tickedId)
  }

  getAdvertisinDataAsync = (id) => {
    this.props.webApi
      .getAdvertisingDetail(id)
      .ajax()
      .then((res) => {
        if (res.registration_info_render_type === "REGISTRATION_RENDER_TYPE_AGENCY") {
          const {
            memo,
            owner_id,
            customer_id,
            we_chat_app_id,
            customer_mp_user_name,
            advertising_info,
            registration_info: { area_code, buying_type, industry_certifications_list, industry_id, legal_person_identity_no, legal_person_name, legal_person_negative, legal_person_positive, license_image_url, license_no, tmall_advertiser_adtype, uname, website_url },
            lead = {},
          } = res

          const { ad_platform_type, advertising_info_id, competition, creative_attachment_ids, creative_attachments, day_budget_promised, effect_promised, landing_page_url, memo_promised, online_time_promised, operation_mode, promoted_object, promotion_business } = advertising_info || {}

          this.setState({
            ownerId: owner_id,
            customerId: customer_id,
            weChatAppId: we_chat_app_id,
            customerMpUserName: customer_mp_user_name,
            basicInfo: {
              buyingType: buying_type,
              uname: uname,
              websiteUrl: website_url,
              licenseNo: license_no,
              licenseImageUrl: license_image_url,
              areaCode: area_code,
              legalPersonName: legal_person_name,
              legalPersonIdentityNo: legal_person_identity_no,
              legalPersonPositive: legal_person_positive,
              legalPersonNegative: legal_person_negative,
              tmallAdvertiserAdtype: tmall_advertiser_adtype,
            },
            industryInfo: {
              industry_id: industry_id,
              industry_certifications_list: industry_certifications_list,
            },
            advertisingInfo: {
              operation_mode: operation_mode,
              ad_platform_type: ad_platform_type,
              promoted_object: promoted_object,
              promotion_business: promotion_business,
              day_budget_promised: day_budget_promised,
              online_time_promised: online_time_promised,
              effect_promised: effect_promised,
              memo_promised: memo_promised,
              competition: competition,
              landing_page_url: landing_page_url,
              creative_attachment_ids: creative_attachment_ids ? creative_attachment_ids : {},
              creative_attachments: creative_attachments,
              advertising_info_id: advertising_info_id,
            },
            memo: memo,
            lead,
          })
        } else if (res.registration_info_render_type === "REGISTRATION_RENDER_TYPE_CS") {
          const {
            memo,
            owner_id,
            customer_id,
            we_chat_app_id,
            customer_mp_user_name,
            advertising_info,
            cs_registration_info: { area_code, buying_type, industry_certifications_list, industry_id, legal_person_identity_no, legal_person_name, legal_person_negative, legal_person_positive, license_image_url, license_no, tmall_advertiser_adtype, uname, website_url },
            lead = {},
          } = res

          const { ad_platform_type, advertising_info_id, competition, creative_attachment_ids, day_budget_promised, effect_promised, landing_page_url, memo_promised, online_time_promised, operation_mode, promoted_object, promotion_business, creative_attachments } = advertising_info || {}

          this.setState({
            ownerId: owner_id,
            customerId: customer_id,
            weChatAppId: we_chat_app_id,
            customerMpUserName: customer_mp_user_name,
            basicInfo: {
              buyingType: buying_type,
              uname: uname,
              websiteUrl: website_url,
              licenseNo: license_no,
              licenseImageUrl: license_image_url,
              areaCode: area_code,
              legalPersonName: legal_person_name,
              legalPersonIdentityNo: legal_person_identity_no,
              legalPersonPositive: legal_person_positive,
              legalPersonNegative: legal_person_negative,
              tmallAdvertiserAdtype: tmall_advertiser_adtype,
            },
            industryInfo: {
              industry_id: industry_id,
              industry_certifications_list: industry_certifications_list,
            },
            advertisingInfo: {
              operation_mode: operation_mode,
              ad_platform_type: ad_platform_type,
              promoted_object: promoted_object,
              promotion_business: promotion_business,
              day_budget_promised: day_budget_promised,
              online_time_promised: online_time_promised,
              effect_promised: effect_promised,
              memo_promised: memo_promised,
              competition: competition,
              landing_page_url: landing_page_url,
              creative_attachment_ids: creative_attachment_ids ? creative_attachment_ids : {},
              creative_attachments: creative_attachments,
              advertising_info_id: advertising_info_id,
            },
            memo: memo,
            lead,
          })
        }
      })
      .catch((err) => {
        this.context.error("拉取信息失败", err.message)
      })
  }

  handleChange(event, key) {
    this.setState({
      key,
    })
  }

  render() {
    const {
      key,
      ownerId,
      customerId,
      weChatAppId,
      customerMpUserName,
      basicInfo: { buyingType, uname, websiteUrl, licenseNo, licenseImageUrl, areaCode, legalPersonName, legalPersonIdentityNo, legalPersonPositive, legalPersonNegative },
      advertisingInfo: { operation_mode, ad_platform_type, promoted_object, promotion_business, day_budget_promised, online_time_promised, effect_promised, memo_promised, competition, landing_page_url, creative_attachments, advertising_info_id },
      industryInfo: { industry_id, industry_certifications_list },
      lead,
    } = this.state

    return (
      <AccountDialog {...this.props}>
        <Tabs onChange={this.handleChange} value={key}>
          <TabPanel tab="开户信息" name="1">
            <div className="form-list-normal form-list-read">
              <div className="lump">
                <div className="lump-bd">
                  <ul className="infos">
                    <li className="infolist">
                      <span className="info-tt">账户类型</span>
                      <div className="info-des">
                        <p className="read-des">{this.renderBuyingType(buyingType)}</p>
                      </div>
                    </li>
                    <li className="infolist">
                      <span className="info-tt">公司名称</span>
                      <div className="info-des">
                        <p className="read-des">{uname}</p>
                      </div>
                    </li>
                    <li className="infolist">
                      <span className="info-tt">公司网站</span>
                      <div className="info-des">
                        <p className="read-des">{websiteUrl}</p>
                      </div>
                    </li>
                    <li className="infolist">
                      <span className="info-tt">法人姓名</span>
                      <div className="info-des">
                        <p className="read-des">{legalPersonName}</p>
                      </div>
                    </li>
                    <li className="infolist">
                      <span className="info-tt">法人身份证</span>
                      <div className="info-des">
                        <p className="read-des">{legalPersonIdentityNo}</p>
                      </div>
                    </li>
                    <li className="infolist">
                      <span className="info-tt">所属行业</span>
                      <div className="info-des">
                        <p className="read-des">
                          <IndustryInfo industryId={Number(industry_id)} />
                        </p>
                      </div>
                    </li>
                    <li className="infolist">
                      <span className="info-tt">营业执照</span>
                      <div className="info-des clearfix">
                        {licenseImageUrl && (
                          <div className="img-list">
                            <div className="imgarea">
                              <img src={licenseImageUrl} alt="" />
                            </div>
                            <p className="img-name">营业执照</p>
                          </div>
                        )}
                      </div>
                    </li>
                    <li className="infolist">
                      <span className="info-tt">全部资质</span>
                      <div className="info-des clearfix">{this.renderIndustryList(industry_certifications_list)}</div>
                    </li>
                    <li className="infolist">
                      <span className="info-tt">开户时间</span>
                      <div className="info-des">
                        <p className="read-des">{lead.gdt_open_created_time}</p>
                      </div>
                    </li>
                    <li className="infolist">
                      <span className="info-tt">审核通过时间</span>
                      <div className="info-des">
                        <p className="read-des">{lead.approval_time}</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel tab="投放信息" name="2">
            <div className="form-list-normal form-list-read">
              <div className="lump">
                <div className="lump-bd">
                  <ul className="infos">
                    <li className="infolist">
                      <span className="info-tt">账户UID</span>
                      <div className="info-des">
                        <p className="read-des">{customerId}</p>
                      </div>
                    </li>
                    <li className="infolist">
                      <span className="info-tt">帐号APPID</span>
                      <div className="info-des">
                        <p className="read-des">{weChatAppId}</p>
                      </div>
                    </li>
                    <li className="infolist">
                      <span className="info-tt">账户原始ID</span>
                      <div className="info-des">
                        <p className="read-des">{customerMpUserName}</p>
                      </div>
                    </li>
                    <li className="infolist">
                      <span className="info-tt">投放平台</span>
                      <div className="info-des">
                        <p className="read-des">{this.renderAdPlatformType(ad_platform_type)}</p>
                      </div>
                    </li>
                    <li className="infolist">
                      <span className="info-tt">运营方式</span>
                      <div className="info-des">
                        <p className="read-des">{this.renderOperationMode(operation_mode)}</p>
                      </div>
                    </li>
                    <li className="infolist">
                      <span className="info-tt">推广目标</span>
                      <div className="info-des">
                        <p className="read-des">{this.renderPromotedObject(promoted_object, ad_platform_type)}</p>
                      </div>
                    </li>
                    <li className="infolist">
                      <span className="info-tt">推广业务/产品/内容</span>
                      <div className="info-des">
                        <p className="read-des">{promotion_business}</p>
                      </div>
                    </li>
                    <li className="infolist">
                      <span className="info-tt">承诺上线每日预算</span>
                      <div className="info-des">
                        <p className="read-des">{day_budget_promised}</p>
                      </div>
                    </li>
                    <li className="infolist">
                      <span className="info-tt">承诺上线时间</span>
                      <div className="info-des">
                        <p className="read-des">{online_time_promised}</p>
                      </div>
                    </li>
                    <li className="infolist">
                      <span className="info-tt">销售团队</span>
                      <div className="info-des">
                        <p className="read-des">
                          <TeamInfo key={ownerId} userId={Number(ownerId)} />
                        </p>
                      </div>
                    </li>
                    <li className="infolist">
                      <span className="info-tt">销售姓名</span>
                      <div className="info-des">
                        <p className="read-des">
                          <UserInfo key={ownerId} userId={Number(ownerId)} />
                        </p>
                      </div>
                    </li>
                    <li className="infolist">
                      <span className="info-tt">上线承诺转化成本</span>
                      <div className="info-des">
                        <p className="read-des">{effect_promised}</p>
                      </div>
                    </li>
                    <li className="infolist">
                      <span className="info-tt">上线承诺备注</span>
                      <div className="info-des">
                        <p className="read-des">{memo_promised}</p>
                      </div>
                    </li>
                    <li className="infolist">
                      <span className="info-tt">竞品投放效果</span>
                      <div className="info-des">
                        <p className="read-des">{competition}</p>
                      </div>
                    </li>
                    <li className="infolist">
                      <span className="info-tt">投放链接</span>
                      <div className="info-des">
                        <p className="read-des">{landing_page_url}</p>
                      </div>
                    </li>
                    <li className="infolist">
                      <span className="info-tt">素材附件</span>
                      <div className="info-des">
                        <p className="read-des clearfix">{this.renderAttachments(creative_attachments)}</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </TabPanel>
        </Tabs>
      </AccountDialog>
    )
  }

  isArray = (o) => {
    return Object.prototype.toString.call(o) === "[object Array]"
  }

  renderBuyingType = (buyingType) => {
    return getMessage(buyingType, "BuyingType")
  }

  renderAdPlatformType = (RegistrationAdPlatformType) => {
    return getMessage(RegistrationAdPlatformType, "RegistrationAdPlatformType")
  }

  renderOperationMode = (operationMode) => {
    return getMessage(operationMode, "OperationMode")
  }

  renderIndustryList = (industryData) => {
    if (!this.isArray(industryData)) return null
    let imagess = []
    industryData.forEach((item) => {
      item.images_list &&
        item.images_list.forEach((image) => {
          imagess.push({
            name: image.image_id,
            url: image.image_url,
          })
        })
    })

    return imagess.map((item, index) => {
      return (
        <div className="img-list" key={index}>
          <div className="imgarea">
            <img src={item.url} alt="" />
          </div>
          <p className="img-name">{item.name}</p>
        </div>
      )
    })
  }

  renderPromotedObject = (promotedObject, adPlatformType) => {
    const promote = _.filter(this.props.promotedObjectRepo[adPlatformType], (item, key) => {
      return key === promotedObject
    })

    return promote[0]
  }

  renderAttachments(attachments) {
    if (!attachments) return null
    return (
      attachments instanceof Array &&
      attachments.length !== 0 &&
      attachments.map((item) => {
        if (item.content_type === "image/jpeg") {
          return (
            <div className="img-list">
              <div className="imgarea">
                <img src={item.url} alt="" />
              </div>
              <p className="img-name">{item.attachment_name}</p>
            </div>
          )
        } else {
          return (
            <div className="img-list">
              <div className="imgarea">
                <a key={item.url} href={item.url} target="_blank" rel="noopener noreferrer">
                  {item.attachment_name}
                </a>
              </div>
            </div>
          )
        }
      })
    )
  }
}

function mapStateToProps(state, ownProp) {
  return {
    promotedObjectRepo: state.promotedObjectRepo,
  }
}

export default withApi(connect(mapStateToProps)(AccountDetail))

AccountDetail.contextType = MessageBox
